/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Ramachandra Gupta, Vusirikala

 Description:
 */
export var INTERDICTION_START = 'INTERDICTION_START';
export var INTERDICTION_INIT = 'INTERDICTION_INIT';
export var INTERDICTION_END = 'INTERDICTION_END';
export var INTERDICTION_RESUME = 'INTERDICTION_RESUME';
export var INTERDICTION_CANCEL = 'INTERDICTION_CANCEL';
export var INTERDICTION_SET_RESPONSE = 'INTERDICTION_SET_RESPONSE';
export var INTERDICTION_CLEAR_RESPONSE = 'INTERDICTION_CLEAR_RESPONSE';
export var INTERDICTION_SET_FAILURE_MESSAGE = 'INTERDICTION_SET_FAILURE_MESSAGE';
export var INTERDICTION_SET_OTP_VIEW_NAME = 'INTERDICTION_SET_OTP_VIEW_NAME';
export var INTERDICTION_SET_OCS_VIEW_NAME = 'INTERDICTION_SET_OCS_VIEW_NAME';
export var INTERDICTION_SET_OCS_FAILURE_MESSAGE = 'INTERDICTION_SET_OCS_FAILURE_MESSAGE';
export var INTERDICTION_CLEAR_FAILURE_MESSAGE = 'INTERDICTION_CLEAR_FAILURE_MESSAGE';
export var INTERDICTION_SET_OOW_QUESTION = 'INTERDICTION_SET_OOW_QUESTION'; // Auth Hierarchy Flow

export var INTERDICTION_INIT_AUTH_VIEW = 'INTERDICTION_INIT_AUTH_VIEW';
export var INTERDICTION_SET_AUTH_VIEW = 'INTERDICTION_SET_AUTH_VIEW';
export var INTERDICTION_AUTH_GET_OOW_VIEW = 'INTERDICTION_AUTH_GET_OOW_VIEW ';
export var INTERDICTION_AUTH_SET_OOW_VIEW = 'INTERDICTION_AUTH_SET_OOW_VIEW ';
export var INTERDICTION_AUTH_SET_OOW_QUESTION = 'INTERDICTION_AUTH_SET_OOW_QUESTION';
export var INTERDICTION_REQUEST_NEW_CODE = 'INTERDICTION_REQUEST_NEW_CODE';
export var INTERDICTION_AUTH_CLEAR_RESPONSE = 'INTERDICTION_AUTH_CLEAR_RESPONSE';
export var INTERDICTION_SET_AUTH_FAILURE_MESSAGE = 'INTERDICTION_SET_AUTH_FAILURE_MESSAGE'; //

export var initInterdiction = function initInterdiction(payload) {
  return {
    type: INTERDICTION_INIT,
    payload: payload
  };
};
export var startInterdiction = function startInterdiction(payload) {
  return {
    type: INTERDICTION_START,
    payload: payload
  };
};
export var endInterdiction = function endInterdiction() {
  return {
    type: INTERDICTION_END
  };
};
export var cancelInterdiction = function cancelInterdiction(url) {
  return {
    type: INTERDICTION_CANCEL,
    url: url
  };
};
export var resumeAfterInterdiction = function resumeAfterInterdiction() {
  return {
    type: INTERDICTION_RESUME
  };
};
export var setResponse = function setResponse(payload) {
  return {
    type: INTERDICTION_SET_RESPONSE,
    payload: payload
  };
};
export var clearResponse = function clearResponse() {
  return {
    type: INTERDICTION_CLEAR_RESPONSE
  };
};
export var setFailureMessage = function setFailureMessage(payload) {
  return {
    type: INTERDICTION_SET_FAILURE_MESSAGE,
    payload: payload
  };
};
export var setOCSFailureMessage = function setOCSFailureMessage(payload) {
  return {
    type: INTERDICTION_SET_OCS_FAILURE_MESSAGE,
    payload: payload
  };
};
export var setOTPViewName = function setOTPViewName(payload) {
  return {
    type: INTERDICTION_SET_OTP_VIEW_NAME,
    payload: payload
  };
};
export var setOCSViewName = function setOCSViewName(payload) {
  return {
    type: INTERDICTION_SET_OCS_VIEW_NAME,
    payload: payload
  };
};
export var setOOWQuestion = function setOOWQuestion(payload) {
  return {
    type: INTERDICTION_SET_OOW_QUESTION,
    payload: payload
  };
};
export var clearFailureMessage = function clearFailureMessage() {
  return {
    type: INTERDICTION_CLEAR_FAILURE_MESSAGE
  };
}; // Auth Hierarchy Flow

export var initAuthView = function initAuthView(payload) {
  return {
    type: INTERDICTION_INIT_AUTH_VIEW,
    payload: payload
  };
};
export var getAuthOOWView = function getAuthOOWView(payload) {
  return {
    type: INTERDICTION_AUTH_GET_OOW_VIEW,
    payload: payload
  };
};
export var setAuthOOWView = function setAuthOOWView(payload) {
  return {
    type: INTERDICTION_AUTH_SET_OOW_VIEW,
    payload: payload
  };
};
export var setAuthOOWQuestion = function setAuthOOWQuestion(payload) {
  return {
    type: INTERDICTION_AUTH_SET_OOW_QUESTION,
    payload: payload
  };
};
export var setAuthView = function setAuthView(payload) {
  return {
    type: INTERDICTION_SET_AUTH_VIEW,
    payload: payload
  };
};
export var requestNewCode = function requestNewCode(payload) {
  return {
    type: INTERDICTION_REQUEST_NEW_CODE,
    payload: payload
  };
};
export var clearAuthResponse = function clearAuthResponse() {
  return {
    type: INTERDICTION_AUTH_CLEAR_RESPONSE
  };
};
export var setAuthFailureMessage = function setAuthFailureMessage(payload) {
  return {
    type: INTERDICTION_SET_AUTH_FAILURE_MESSAGE,
    payload: payload
  };
};